import { THEME } from '@enmon/commons';
import { queryClient } from 'api/services/queryClient';
import { PublicApp } from 'containers/public';
import { ServicesProvider } from 'containers/services';
import './index.css';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { ThemeProvider } from 'styled-components';
import { AppIntlProvider } from 'containers/intl';
import { AppApolloProvider } from 'containers/apollo/Provider';
import { initializeDayJS } from 'utils/date/dayjs';
import { AppAntConfigProvider } from 'containers/ant-config-provider/AppAntConfigProvider';
import GlobalStyle from 'global-styles';
import 'antd/dist/reset.css';

initializeDayJS();

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <RecoilRoot>
    <ThemeProvider theme={THEME}>
      <GlobalStyle />
      <AppApolloProvider>
        <QueryClientProvider client={queryClient}>
          <AppAntConfigProvider>
            <ServicesProvider>
              <BrowserRouter>
                <AppIntlProvider>
                  <PublicApp />
                </AppIntlProvider>
              </BrowserRouter>
            </ServicesProvider>
          </AppAntConfigProvider>
        </QueryClientProvider>
      </AppApolloProvider>
    </ThemeProvider>
  </RecoilRoot>,
);
